"use strict";

/*global
 window, document, console, require, Foundation
 */

import 'lib/foundation-explicit-pieces';

document.addEventListener('DOMContentLoaded', () => {
    $(document).foundation();



// NAV BURGER
	$('.nav-icon').click(function(){
		$(this).toggleClass('open');
		$('nav').toggleClass('open');
		$('.top-bar').toggleClass('open');
	});

	$('body').on('click', '.aika', function () {
		$('.aika').removeClass('selected');
		$(this).addClass('selected');
	});


// SCROLL TO ANCHOR
	$(".aika").click(function() {
		var hash = $(this).data('hash');

		console.log('this: #' + hash);

		var el = $('#' + hash);

		$('html, body').animate({
			scrollTop: el.offset().top - 200
		}, 500)

	});




// NEWS LOAD MORE
	$('body').on('click', '.load-more', function(){

		const btn = $(this);
		let paged = 1;
		let cat = '';

		if (btn.hasClass('load-more')){
			paged = $(this).data('paged') + 1;
		} else {
			if (btn.hasClass('selected')){
				btn.removeClass('selected');
			} else {
				$('.load-news').removeClass('selected');
				btn.addClass('selected');
			}
		}

		cat = $('.load-news.selected').data('cat') ? $('.load-news.selected').data('cat') : '';
		$('.load-news').prop('disabled', true);
		$('.load-news').prop('disabled', false);

		var showDisableLayer = function() {
			$('<div class="overlay"><div class="color"></div><div class="spinner"></div></div>').appendTo(document.body);
		};
		var hideDisableLayer = function() {
			$(".overlay").fadeOut(500).remove();
		};

		$.ajax({
			url: brbrApp.ajaxUrl,
			type: 'GET',
			data: {
				action: 'get_cases',
				cat: cat,
				paged: paged,
			},

			beforeSend: function() {
				$('.load-news').prop('disabled', true);
				$('.load-news').addClass('disabled');
				showDisableLayer(); // Show the layer of glass.
			},
			success:function(data){
				$('.load-news').prop('disabled', false);
				$('.load-news').removeClass('disabled');
				hideDisableLayer(); // Hides the layer of glass.
			}

		}).always(function(data){

			if (data.html) {
				$('.load-more').data('paged', paged);

				if(btn.hasClass('load-more')) {
					$('.article-list').append(data.html);
				} else {
					$('.article-list').html(data.html);
				}
				if (data.maxpages <= paged) {
					$('.load-more').addClass('disabled').hide();
					$('.all-loaded').delay(1500).fadeIn(1000);
				} else {
					$('.load-more').removeClass('disabled').show();
				}
			}
		});
	});

});